import { render, staticRenderFns } from "./Tinput.vue?vue&type=template&id=5dfdb492&"
import script from "./Tinput.vue?vue&type=script&lang=js&"
export * from "./Tinput.vue?vue&type=script&lang=js&"
import style0 from "./Tinput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports